<template>
    <div id="testimoni">
        <v-breadcrumbs
            :items="[
                { text: 'Dashboard', to: { path: '/' } },
                { text: 'Testimoni' },
            ]"
            divider="|"
        ></v-breadcrumbs>

        <h3 class="header-text font-weight-bold">Testimoni</h3>

        <v-card>
            <v-card-title>
                Daftar Testimoni
                <v-spacer></v-spacer
                ><v-btn
                    class="align-center text-body-2 blew white--text"
                    text
                    @click="createTestimoni()"
                    ><v-icon small class="pr-2">mdi-plus-circle</v-icon>
                    Tambah Testimoni
                </v-btn>
            </v-card-title>

            <v-divider />

            <app-datatable
                :items="testimoniList"
                :headers="headers"
                :hasAction="true"
                :has-custom-pagination="true"
                :custom-pagination-total-items="pagination.total_data"
                :custom-pagination-current-page="pagination.currentPage"
                :custom-pagination-per-page="pagination.perPage"
                :custom-pagination-total-pages="pagination.totalPages"
                :custom-pagination-sort-mode="pagination.sortMode"
                v-on:selected="selectedRow = $event"
                :loading="isLoading"
                v-on:dblClicked="updateTestimoni()"
                v-on:deleted="confirmDelete($event)"
                v-on:changePage="
                    pagination = { ...pagination, currentPage: $event }
                "
                v-on:changeSortMode="
                    pagination = { ...pagination, sortMode: $event }
                "
                v-on:doSearch="
                    search = { query: $event.value, by: headersKey[$event.key] }
                "
            ></app-datatable>
        </v-card>

        <v-dialog v-model="dialogConfirm.open" persistent max-width="450">
            <dialog-confirm
                :title="dialogConfirm.title"
                :subtitle="dialogConfirm.subtitle"
                @close="
                    dialogConfirm.open = false;
                    dialogConfirm.title = null;
                    dialogConfirm.function = null;
                "
                @confirm="
                    deleteTestimoni(dialogConfirm.function);
                    dialogConfirm.open = false;
                    dialogConfirm.title = null;
                    dialogConfirm.function = null;
                "
            />
        </v-dialog>

        <app-spinner v-if="isLoading"></app-spinner>
    </div>
</template>

<script>
import DataTable from "@/modules/global/components/plugins/DataTable-c";
import SalesService from "@/modules/global/services/sales.js";
import Spinner from "@/modules/global/components/plugins/Spinner";
import DialogConfirm from "@/modules/global/components/DialogConfirm";

export default {
    name: "Testimoni",

    components: {
        "app-datatable": DataTable,
        "app-spinner": Spinner,
        "dialog-confirm": DialogConfirm,
    },

    data: function () {
        return {
            isLoading: false,
            testimoniList: [],
            selectedRow: null,
            search: null,
            pagination: {
                perPage: 10,
                currentPage: 1,
                totalPages: 0,
                sortMode: "desc",
                total_data: 0,
            },
            headers: [
                { text: "Aksi", value: "actions" },
                { text: "Nama", value: "name" },
                { text: "Jenjang", value: "level" },
                { text: "Kelas", value: "grade" },
                { text: "Rating", value: "rating" },
                { text: "Nama Paket", value: "package_name" },
                { text: "Testimoni", value: "testimoni" },
            ],
            headersKey: [
                "name",
                "level",
                "grade",
                "rating",
                "package_name",
                "testimoni",
            ],
            dialogConfirm: {
                open: false,
                title: null,
                subtitle: null,
                function: null,
            },
        };
    },

    mounted: function () {
        this.fetchData();
    },

    watch: {
        pagination: function () {
            this.fetchData();
        },
        search() {
            if (this.search.by && this.search.query) this.fetchData();
        },
    },

    methods: {
        fetchData: function () {
            var context = this;
            var search = this.search;
            var pagination = {
                perPage: this.pagination.perPage,
                currentPage: this.pagination.currentPage,
                sortMode: this.pagination.sortMode,
            };

            // if (this.$store.state.datatable.filter) {
            //   search = {
            //     query: this.$store.state.datatable.filter.value,
            //     by: this.headersKey[this.$store.state.datatable.filter.key],
            //   };
            // } else {
            //   search = this.search;
            // }
            // if (search) {
            //   search.query = encodeURIComponent(search.query);
            // }

            // context.isLoading = true;
            SalesService.getTestimoni(pagination, search, (result) => {
                context.testimoniList = [];
                if (result.success) {
                    context.pagination.totalPages = result.data.max_page;
                    context.pagination.total_data = result.data.total_data;
                    result.data.testimonies.forEach(function (data, index) {
                        var row = {
                            no: index,
                            id: data.testimoni_id,
                            name: data.student_name,
                            level: data.level,
                            grade: data.grade,
                            rating: data.rating,
                            package_name: data.package_name,
                            testimoni: data.testimoni,
                        };
                        if (data.is_show) {
                            context.testimoniList.push(row);
                        }

                        context.isLoading = false;
                    });
                }
                context.isLoading = false;
            });
        },

        createTestimoni: function () {
            this.$router.push({ path: "/testimoni/form" });
        },

        updateTestimoni: function () {
            var testimoniID = this.selectedRow.id;
            this.$router.push({
                path: "/testimoni/form",
                query: { id: testimoniID },
            });
        },

        confirmDelete: function (testimoni) {
            this.dialogConfirm.title = "Hapus Data Testimoni?";
            this.dialogConfirm.subtitle =
                "Apakah Anda yakin ingin menghapus data ini?";
            this.dialogConfirm.function = testimoni;
            this.dialogConfirm.open = true;
        },

        deleteTestimoni: function (testimoni) {
            var context = this;
            var testimoniId = testimoni.id;

            SalesService.hapusTestimoni(testimoniId, function (result) {
                context.isLoading = false;
                if (result.success) {
                    context.$store.commit("showAlert", {
                        message: `Data Testimoni Terhapus`,
                        type: "success",
                    });
                    context.fetchData();
                } else {
                    context.$store.commit("showAlert", {
                        message: `Data gagal terhapus`,
                        type: "error",
                    });
                }
                return;
            });

            this.dialogConfirm.open = false;
            this.dialogConfirm.title = null;
            this.dialogConfirm.function = null;
        },
    },
};
</script>



// WEBPACK FOOTER //
// Testimoni.vue?eb3f1640